import { useField, useFormikContext } from "formik";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { TextField } from "@mui/material";

export const CustomDatePicker = ({
  ...props
}: {
  [x: string]: any;
  name: string;
  label: string;
  isRequired?: boolean;
  onUpdate?: any;
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field, meta] = useField(props);

  return (
    <div className="resume-create-form z-10">
      <DatePicker
        selected={(field.value && new Date(field.value)) || null}
        onChange={(val) => {
          setFieldValue(field.name, val?.toISOString().split("T")[0]);
          setFieldTouched(field.name, true);
          props.onUpdate && props.onUpdate(field.name, val?.toISOString().split("T")[0])
        }}
        className="!w-full"
        {...props}
        required={props.isRequired}
        placeholderText={"Please select a date"}
        readOnly={props.dialogAction === EDialogAction.view}
        dateFormat="yyyy-MM-dd"
        isClearable
        showYearDropdown
        yearDropdownItemNumber={200}
        scrollableYearDropdown
        customInput={
          <TextField {...field}
            className="w-full"
            sx={{width: "100%"}}
            variant="outlined"
            label={props.label}
            helperText={
              meta.error && meta.touched &&
              String(meta.error)
            }
            error={Boolean(meta.touched && meta.error)}
            required={props.isRequired} />}
      />
    </div>
  );
};